const colors = {
  White: '#ffffff',
  'Dark Neutral 1': '#3C4757',
  'Mid Neutral 1': '#637282',
  'Mid Neutral 2': '#9DA3B1',
  'Mid Neutral 3': '#D0D7E0',
  'Light Neutral 1': '#E5E9F1',
  'Light Neutral 2': '#F2F4F8',
  'Light Neutral 3': '#F9FAFC',
  Orange: '#EE734C',
  'Orange AA': '#E95628',
  'Light Orange 1': '#EF9072',
  'Light Orange 2': '#FDC1AE',
  'Light Orange 3': '#FFECE7',
  Blue: '#3F84D6',
  'Blue AA': '#3173C2',
  'Light Blue 1': '#70ACF2',
  'Light Blue 2': '#ABD0FB',
  'Light Blue 3': '#E8F2FF',
  Green: '#2EA970',
  'Green AA': '#239861',
  'Light Green 1': '#85D2AF',
  'Light Green 2': '#CEF0DA',
  'Light Green 3': '#EBF8F2',
  Yellow: '#FAB666',
  'Yellow AA': '#E39C2E',
  'Light Yellow 1': '#FDC572',
  'Light Yellow 2': '#FFDEAB',
  'Light Yellow 3': '#FFF5E4',
  Red: '#EE5C65',
  'Red AA': '#D75058',
  'Light Red 1': '#FFF2F3',
  'Light Red 2': '#F37E85',
  'Light Red 3': '#FEC3C6',
  Purple: '#C9A1F0',
};

export default colors;
